import { CaretRightEnabled, CaretLeftEnabled } from '@carvana/purchase-icons';
import styled, { css } from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export const PaginationBadge = styled.div`
  color: white;
  font-weight: 450;
  font-size: 0.875rem;
  background-color: #6d7184;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
`;

export const PaginationButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  padding: 0.5rem;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #6d7184;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const svgStyles = css`
  color: #fff;
  stroke: #fff;
`;

export const CaretRight = styled(CaretRightEnabled)`
  ${svgStyles}
`;

export const CaretLeft = styled(CaretLeftEnabled)`
  ${svgStyles}
`;
